<h5 class="card-title">{{origin | uppercase}}: {{display_name | uppercase}}</h5>
<div class="card-body">
    <ngx-loading [show]="loadingIndicator" ></ngx-loading>
    <button type="button" class="btn btn-sm btn-secondary mb-1" (click)="openFileModal(mCreateUserFile, null)"><span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-lg fa-file"></i></span> Create File</button>&nbsp;&nbsp;
    <button type="button" class="btn btn-sm btn-secondary mb-1" (click)="printer.print('print-section', 'User Files')" [disabled]="uFileCount < 1"><span class="badge badge-pill badge-white text-primary ml-1"><i class="fa fa-lg fa-print"></i></span> Print</button>&nbsp;&nbsp;
    <div class="btn-group mr-1">
        <button type="button" class="btn btn-sm btn-secondary mb-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" [disabled]="uFileCount < 1"
        placement="bottom" ngbTooltip="Export List">
            <i class="fa fa-lg fa-download"></i><span >&nbsp; Export</span>
        </button>
        <div class="dropdown-menu fs-12">
            <a (click)="file_exportToCSV()" class="dropdown-item" href="javascript:void(0);">Export to CSV</a> 
            <a (click)="file_exportToExcel()" class="dropdown-item" href="javascript:void(0);">Export to Excel</a> 
            <a (click)="file_exportToPDF()" class="dropdown-item" href="javascript:void(0);">Export to PDF</a> 
        </div>
    </div>
    <select [(ngModel)]="filterDropdown" (ngModelChange)="onChangeFilterDropdown($event)"
        class="dateFilter  btn btn-sm  btn-secondary mb-1 mr-1 pull-right">
        <option value="files">Verified Files</option>
        <option value="unverified">Unverified Files</option>
        <option value="archived">Archived Files</option>
        <option value="all">All Files</option>
    </select>

    <div class="col-12" *ngIf="uFileCount > 0">
        <br/>
        <ngx-datatable *ngIf="uFileCount > 0 && !loadingIndicator"
            [loadingIndicator]="loadingIndicator"
            class="material"
            [rows]="uFiles"
            [columnMode]="'force'"
            [columns]="columns2"
            [footerHeight]="40"
            [limit]="10"
            [selected]="selected_file"
            [selectionType]="'single'"
            [scrollbarH]="true"
            [rowHeight]="'auto'"
            >
        

            <ngx-datatable-column prop="id" name="Operations" headerClass="header" [width]="60" [cellClass]="getCellClassDoc"> 
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <div align="left" style="padding-right:20px">  
                        <a class="fa fa-lg fa-trash" title="Delete File" (click)="openFileModal(mDeleteFile, row);"></a>&nbsp;
                        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
                        <a *ngIf="row.is_viewable == 0" class="fa fa-lg fa-eye" [hidden]="spinner == true" title="Mark as Viewable" (click)="updateViewFile(row, 1)"></a>
                        <a *ngIf="row.is_viewable == 1" class="fa fa-lg fa-eye-slash" [hidden]="spinner == true" title="Mark as not viewable" (click)="updateViewFile(row, 0)"></a>&nbsp;
                        <i class="fa fa-spinner fa-spin" *ngIf="spinner2 == true"></i>
                        <a *ngIf="row.verified == 0" class="fa fa-lg fa-check-circle-o" [hidden]="spinner2 == true" title="Verify File" (click)="verifyFile(row)"></a> 
                    </div>
                </ng-template>
            </ngx-datatable-column>
            
            <ngx-datatable-column name="Date Added" prop="date_added"  headerClass="header" [width]="100" [cellClass]="getCellClassDoc">
                <ng-template let-value="value" ngx-datatable-cell-template>
                    {{ (value !== null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Description" prop="description"  headerClass="header"  [width]="200" [cellClass]="getCellClassDoc">
                <ng-template let-value="value" ngx-datatable-cell-template>
                    <div style="padding-right:5px; overflow: hidden; width: 100%; word-wrap: break-word;">{{ value }}</div>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="File" prop="filename"  headerClass="header"  [width]="200" [cellClass]="getCellClassDoc">
                <ng-template let-value="value" ngx-datatable-cell-template>
                    <div style="padding-right:5px; overflow: hidden; width: 100%; word-wrap: break-word; ">
                        <a href="{{folderPath}}{{value}}" target="_new">{{value}}</a>
                    </div>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Expiry" prop="expiry"  headerClass="header" [width]="100" [cellClass]="getCellClassDoc">
                <ng-template let-value="value" ngx-datatable-cell-template>
                    {{ (value !== null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Expiry" prop="expiry"  headerClass="header" [width]="100" [cellClass]="getCellClassDoc">
                <ng-template let-value="value"  let-row="row" ngx-datatable-cell-template>
                    <span *ngIf="row.is_expired == 1"><i class="text-danger"> {{ (value !== null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }} <br/> (Expired)</i></span>
                    <span *ngIf="row.is_expired == 0"> {{ (value !== null && value != '0000-00-00') ? (formatDate(value) | date: 'dd MMM yyyy') : "No Date"  }}</span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Induction Task" prop="induction_tasks_title"  headerClass="header"  [width]="200" [cellClass]="getCellClassDoc">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <div style="padding-right:5px; overflow: hidden; width: 100%; word-wrap: break-word;">
                        {{value}}<span *ngIf="row.induction_record_status == 4"><br/><i class="text-danger">(Marked for Reinduction)</i></span>
                    </div>
                </ng-template>
            </ngx-datatable-column>


            <ngx-datatable-column prop="created_name" name="Created By" headerClass="header" [cellClass]="getCellClassDoc">
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                    <div style="padding-right:5px; overflow: hidden; width: 100%; word-wrap: break-word;">
                        {{value}}<span *ngIf="row.induction_record_status == 4"><br/><i class="text-danger">(Marked for Reinduction)</i></span>
                    </div>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="updated_name" name="Updated By" headerClass="header" [cellClass]="getCellClassDoc">
                <ng-template let-value="value" ngx-datatable-cell-template>
                    <div style="padding-right:5px; overflow: hidden; width: 100%; word-wrap: break-word;">{{ value }}</div>
                </ng-template>
            </ngx-datatable-column> 

            <ngx-datatable-column prop="created_at" name="Created Date" headerClass="header" [cellClass]="getCellClassDoc">
                <ng-template let-value="value" ngx-datatable-cell-template>
                    {{ (value !== null && value != '0000-00-00 00:00:00') ? (value | date: 'dd MMM yyyy h:mm a') : "No Date"  }}
                </ng-template>
            </ngx-datatable-column> 

            <ngx-datatable-column prop="updated_at" name="Updated Date" headerClass="header" [cellClass]="getCellClassDoc">
                <ng-template let-value="value" ngx-datatable-cell-template>
                    {{ (value !== null && value != '0000-00-00 00:00:00') ? (value | date: 'dd MMM yyyy h:mm a') : "No Date"  }}
                </ng-template>
            </ngx-datatable-column> 
        </ngx-datatable>
    </div>
    <p *ngIf="uFileCount == 0">No file record of this type for this {{origin | lowercase}}.</p>
</div>



<!-- START OF DELETE FILE FORM -->
<ng-template #mDeleteFile let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Delete File</h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div class="row pt-0">
            <div class="col-md-12">
               Do you really want to delete <b><i>{{userFile.description}} - {{userFile.filename}}</i></b>?
            </div>
      
        </div>
    </div>
    <div class="modal-footer">
        <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
        <button type="button" class="btn btn-sm btn-danger"  (click)="deleteFile(userFile)"  [disabled]="spinner == true">Delete</button>
        <button type="button" class="btn btn-sm btn-secondary" (click)="close()">Cancel</button>
    </div>
</ng-template>
<!-- END OF MODAL DELETE FILE FORM -->

<!-- START OF ADD FILE FORM -->
<ng-template #mCreateUserFile let-close="close">
    <div class="modal-header">
            <h5 class="modal-title">Create New File</h5>
            <button type="button" class="close" (click)="close();modalReset();">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="frmUserFile" novalidate (ngSubmit)="onSubmitUserFile(frmUserFile.value)">
        <div class="modal-body">
            <div class="row">
                <div class="form-group col-md-6" >
                    <label class="form-control-label">Date Added<span class="text-danger">*</span></label>
                    <my-date-picker name="date_added" [options]="myDatePickerOptions" [placeholder]="placeholder" formControlName="date_added" (dateChanged)="onDateChanged($event, 'date_added')"></my-date-picker>
                    <div *ngIf="frmUserFile.controls.date_added.touched" >
                        <div *ngIf="frmUserFile.controls.date_added.errors?.required">
                            <small class="text-danger" >Date added is required.</small>
                        </div>
                    </div>
                </div>
                <div class="form-group col-md-6" >
                    <label class="form-control-label">Description<span class="text-danger">*</span></label>
                    <input formControlName="description" class="form-control form-control-sm" type="text" required> 
                    <div *ngIf="frmUserFile.controls.description.touched" >
                        <div *ngIf="frmUserFile.controls.description.errors?.required">
                            <small class="text-danger" >Description is required.</small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-md-6" >
                    <label class="form-control-label">Expiry Date</label>
                    <my-date-picker name="expiry" [options]="myDatePickerOptions" [placeholder]="placeholder" formControlName="expiry" (dateChanged)="onDateChanged($event, 'expiry')"></my-date-picker>
                </div>
                <div class="form-group">
                    <label class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" formControlName="is_viewable" ng-true-value="1" ng-false-value="0">
                        <span class="custom-control-indicator"></span>
                        <span class="custom-control-label">Is Viewable</span>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="form-group col-md-6">
                    <label class="form-control-label">Induction Task</label>
                    <select formControlName="induction_task_id" class="form-control form-control-sm">
                        <option *ngFor="let dt of document_tasks" value="{{dt.set_tasks_id}}">{{dt.set_tasks_title}}</option>
                    </select>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label class="text-gray">File:<span class="text-danger">*</span> </label>
                        <app-file-uploader (passFile)="getFile($event, origin)"></app-file-uploader>
                    </div>
                    <small><i>*Note: Allowed files are *.pdf, image files (*png,*.jpg,*.gif).</i></small>
                    <div *ngIf="frmUserFile.controls.filename.errors?.required || !frmFile">
                        <small class="text-danger" >File is required.</small>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <small class="mr-auto"><i> Note: <span class="text-danger">*</span> = required</i></small>
            <i class="fa fa-spinner fa-spin" *ngIf="spinner == true"></i>
            <button [disabled]="!frmUserFile.valid || spinner == true || !frmUserFile.dirty || !frmFile" type="submit" class="btn btn-sm btn-success" >Save</button>
            <button type="button" class="btn btn-sm btn-secondary" (click)="close();modalReset();" >Cancel</button>
        </div>
    </form>
</ng-template>
<!-- END OF MODAL FILE FORM -->


<!-- print -->
<div id="print-section" style="display:none">
    <table style="width:100%">
        <thead>
            <tr> 
                <th><small><strong>Date Added</strong></small></th> 
                <th><small><strong>Description</strong></small></th>
                <th><small><strong>Filename</strong></small></th>
                <th><small><strong>Expiry</strong></small></th>
                <th><small><strong>Induction Task</strong></small></th>          
                <th><small><strong>Created By</strong></small></th>
                <th><small><strong>Updated By</strong></small></th>
                <th><small><strong>Created Date</strong></small></th>
                <th><small><strong>Updated Date</strong></small></th>             
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let uf of uFiles">    
                <td><small>{{ (uf.date_added !== null && uf.date_added != '0000-00-00') ? (formatDate(uf.date_added) | date: 'dd MMM yyyy') : "No Date"  }}</small></td>
                <td><small>{{uf.description}}</small></td>
                <td><small>{{uf.filename}}</small></td>
                <td><small>{{ (uf.expiry !== null && uf.expiry != '0000-00-00') ? (formatDate(uf.expiry) | date: 'dd MMM yyyy') : "No Date"  }}</small></td>
                <td><small>{{uf.induction_tasks_title}}</small></td>
                <td><small>{{uf.created_name}}</small></td>
                <td><small>{{uf.updated_name}}</small></td>      
                <td><small>{{ (uf.created_at !== null && uf.created_at != '0000-00-00 00:00:00') ? (uf.created_at | date: 'dd MMM yyyy h:mm a') : "No Date"  }}</small></td>
                <td><small>{{ (uf.updated_at !== null && uf.updated_at != '0000-00-00 00:00:00') ? (uf.updated_at |  date: 'dd MMM yyyy h:mm a') : "No Date"  }}</small></td>
            </tr>
        </tbody>      
    </table>
</div>